import React from 'react';

const SportStrip = () => {
  const sports = [
    { name: 'Boxing', primary: true },
    { name: 'MMA', primary: true },
    { name: 'Kickboxing', primary: false },
    { name: 'Soccer / UEFA', primary: false },
    { name: "Women's Football", primary: false },
    { name: 'X Games', primary: false },
    { name: 'Esports', primary: false },
    { name: 'Fishing', primary: false },
    { name: 'US Sports News', primary: false }
  ];

  const handleChipClick = () => {
    window.location.href = 'https://www.dazn.com/en-IN/welcome/en-IN/welcome';
  };

  return (
    <div className="sport-strip">
      {sports.map((sport, index) => (
        <div 
          key={index} 
          className={`sport-chip ${sport.primary ? 'primary' : ''}`}
          onClick={handleChipClick}
        >
          {sport.name}
        </div>
      ))}
    </div>
  );
};

export default SportStrip;
